module.exports = __webpack_public_path__ + "img/promotion.419f0a7c.png";